import React, { useEffect } from 'react';
import { Input, Tabs } from 'antd';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useAgentSelector } from '../../hooks/useAgentStore';
import './MarkdownEditor.less';
import { MarkdownText } from '../../interfaces/markdown';
import { SanitizedMarkedHtml } from '../../utils/MarkedHtml';
import { getReadonlyElementTitle } from '../../services/subscription';

interface MarkdownEditorProps {
  value?: MarkdownText;
  onChange?: (value: MarkdownText) => void;
  isReadonly?: boolean;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value = { markdownText: '', isPreviewMode: false, showTabs: false },
  onChange,
  isReadonly,
}) => {
  const { loading } = useAgentSelector((state) => state.changeRequest);
  const { markdownText, isPreviewMode, showTabs } = value;

  useEffect(() => {
    if (showTabs) {
      document.getElementById('markdown-editor-textarea')?.focus();
    }
  }, [showTabs]);

  const handleTextChange = (text: string) => {
    onChange?.({ markdownText: text, isPreviewMode: false, showTabs: true });
  };

  const renderPreview = () => {
    const sanitizedHtml = SanitizedMarkedHtml(markdownText);

    return (
      <div id="markdown-editor-preview">
        <div
          id="markdown-preview"
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
      </div>
    );
  };

  return (
    <div id="markdown-editor" className={`${showTabs ? 'show-tabs' : ''}`}>
      <Tabs
        type="card"
        activeKey={isPreviewMode ? '2' : '1'}
        onChange={(key) =>
          onChange?.({
            markdownText,
            isPreviewMode: key === '2',
            showTabs: true,
          })
        }
        items={[
          {
            key: '1',
            label: (
              <span>
                <EditOutlined /> Write
              </span>
            ),
            children: (
              <div>
                <Input.TextArea
                  id="markdown-editor-textarea"
                  autoSize={{ minRows: 10, maxRows: 15 }}
                  value={markdownText}
                  disabled={loading || isReadonly}
                  onChange={(e) => handleTextChange(e.target.value)}
                  placeholder={
                    isReadonly
                      ? getReadonlyElementTitle()
                      : 'Describe the details of your request...'
                  }
                />
              </div>
            ),
          },
          {
            key: '2',
            label: (
              <span>
                <EyeOutlined /> Preview
              </span>
            ),
            children: <div>{renderPreview()}</div>,
          },
        ]}
      />
    </div>
  );
};

export default MarkdownEditor;
